import type { IComment } from "../types/comment";
import { Box, Typography } from "@mui/material";
import { useMemo } from "react";

import Comment from "./Comment";
import type { IPost } from "../types/post";
import type { IRecipeSetComment } from "./SavedRecipe";

export type SetImageBoxCommentData = (type: "likes" | "commentText" | "commentLike", comment?: IComment, commentId?: string) => void;

interface ICommentsProps {
    type: "ImageBox" | "Post" | "Recipe";
    comments: IComment[];
    setData?: SetImageBoxCommentData | React.Dispatch<React.SetStateAction<IPost>> | IRecipeSetComment;
}

const Comments: React.FC<ICommentsProps> = ({ type, comments = [], setData = undefined }) => {
    const renderComments = useMemo(() => {
        if (comments.length === 0)
            return (
                <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                    <Typography sx={{ color: "#888888ff" }}> Be the first to comment! </Typography>
                </Box>
            );

        return [...comments]
            .reverse()
            .map((comment: IComment) => <Comment key={comment._id} comment={comment} setData={setData} type={type} />);
    }, [comments, setData, type]);

    return <Box>{renderComments}</Box>;
};

export default Comments;
